import { CompareContractsOutput } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { isUndefined } from 'lodash';
import { ExtractResult, TableResult, TableRow } from 'src/components/CompareContracts/utils/comparison-extractor';

export function getLength(list: TableRow[] | undefined, includeMatchingData: boolean = false): number {
    if (isUndefined(list)) {
        return 0;
    }
    if (includeMatchingData) {
        return list.length;
    } else {
        return list.filter((row) => !row.isExactMatch).length;
    }
}

export function getChanges(result?: TableResult): number {
    return getLength(result?.left?.rows) + getLength(result?.center?.rows) + getLength(result?.right?.rows);
}

type SizeEntry = {
    table?: string;
    size: number;
};

export function getTableWithLargestDiff(comparisons: ExtractResult): string | undefined {
    const largestDiff = Object.keys(comparisons)
        .map<SizeEntry>((key) => ({ table: key, size: getChanges(comparisons[key]) }))
        .reduce<SizeEntry>(
            (max, cur) => {
                return cur.size > max.size ? cur : max;
            },
            { size: 0 }
        );

    return largestDiff.table;
}

export function countDifferences(comparison: CompareContractsOutput): number {
    return comparison.deltas
        .map((delta) => {
            if (delta.isExactMatch) {
                return 0;
            } else if (delta.left.length === 1 && delta.right.length === 1) {
                return 1;
            } else {
                return delta.left.length + delta.right.length;
            }
        })
        .reduce((x, y) => x + y, 0);
}
